import React, { useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import { FormikErrors, FormikTouched } from "formik";
import { IDanhSachDanhMuc } from "../../phan-he-tiep-nhan-thanh-toan/models/TiepDonModel";
import { getIndexedDBItem } from "../../utils/IndexedDB";
import { KEY_DS_DANH_MUC_TIEP_DON } from "../../utils/Constant";
import SelectTableVirtualized from "./select-thuoc-button/SelectTableVirtualized";
import TextField from "../../component/TextField";
import clsx from "clsx";

type Props = {
  encounterDiagnosisValues: any;
  encounterDiagnosisErrors: FormikErrors<any>;
  encounterDiagnosisTouched: FormikTouched<any>;
  benhNhanInfo?: any;
  listComorbidity: any;
  setListComorbidity: (value: any) => void;
  disabled?: boolean;
  icd10Field?: string;
  comorbidityField?: string;
  diagnosisNonCodedField?: string;
  onChange: (value: any) => void;
  handleChangeEncounterDiagnosis: (name: any, value: any) => void;
  rowClassName?: string;
  hasDiagnosisNonCoded?: boolean;
  endRowClassName?: string;
  comorbidityCodeField?: string;
  fieldLabel?: string;
  diagnosisList?: any[];
};

const ProvisonalDiagnosis = (props: Props) => {
  const {
    encounterDiagnosisValues,
    encounterDiagnosisErrors,
    encounterDiagnosisTouched,
    benhNhanInfo,
    listComorbidity,
    setListComorbidity,
    disabled = false,
    icd10Field = "provisionalDiagnosis",
    comorbidityField = "comorbidity",
    diagnosisNonCodedField = "diagnosisNonCoded",
    onChange,
    handleChangeEncounterDiagnosis,
    rowClassName,
    hasDiagnosisNonCoded = true,
    endRowClassName,
    comorbidityCodeField = 'comorbidityCode',
    fieldLabel = 'ICD10',
    diagnosisList,
  } = props;
  
  const [listICD10, setListICD10] = useState<any[]>([]);
  const isDisabled = benhNhanInfo ? !benhNhanInfo?.thongTinKhamBenh?.isExamined : disabled;

  useEffect(() => {
    handleGetListICD10();
  }, [diagnosisList?.length]);

  const handleSelectedICD10 = (value: any) => {
    let valueAdd = {
      termName: value?.rowData?.name,
      termCode: value?.rowData?.code,
      isDiseaseMain: true,
    };
    let newArr = [];
    let arrAfter = [];
    let hasDiagnosis = listComorbidity?.some((item: any) => {
      return item.termCode === value?.rowData?.code;
    });
    if (!hasDiagnosis) {
      if (listComorbidity?.length) {
        newArr = [
          ...listComorbidity?.filter((item: any) => {
            return !item?.isDiseaseMain;
          }),
          valueAdd,
        ];
      } else {
        newArr = [
          {
            ...valueAdd,
          },
        ];
      }
      arrAfter = newArr.filter((item: any) => !item?.isDiseaseMain);
    } else {
      newArr = listComorbidity?.map((item: any) => {
        if (item.termCode === value?.rowData?.code) {
          item.isDiseaseMain = true;
        } else {
          item.isDiseaseMain = false;
        }
        return item;
      });
      arrAfter = newArr.filter((item: any) => !item?.isDiseaseMain);
    }
    setListComorbidity(newArr);
    onChange({
      [icd10Field]: value?.rowData?.code,
      [icd10Field + "Name"]: value?.rowData?.name,
      [comorbidityField]: arrAfter?.map((item: any) => item?.termName).join("; "),
      [comorbidityCodeField]: arrAfter?.map((item: any) => item?.code).join("; "),
    });
  };

  const handleGetListICD10 = async () => {
    try {
      if (diagnosisList?.length) {
        setListICD10(diagnosisList);
        return;
      }

      let res: IDanhSachDanhMuc = await getIndexedDBItem(
        KEY_DS_DANH_MUC_TIEP_DON
      );
      setListICD10(res?.listICD10 || []);
    } catch (error) {
      console.error(error);
    }
  };

  const columnSelectTable = [
    {
      name: "",
      field: "radio",
      width: 50,
      textAlign: "center",
    },
    {
      name: fieldLabel,
      field: "code",
      width: 200,
      textAlign: "center",
    },
    {
      name: "Tên bệnh",
      field: "name",
      width: 892,
      textAlign: "left",
    },
  ];

  return (
    <>
      <Col xs="3" className={clsx("pe-0", rowClassName)}>
        <SelectTableVirtualized
          value={encounterDiagnosisValues?.[icd10Field] || ""}
          setICD10Selected={(value) => {
            handleSelectedICD10(value);
          }}
          columns={columnSelectTable}
          data={listICD10}
          label=""
          labelClassName="min-w-120-px"
          disabled={isDisabled}
          keyword="code"
          name={icd10Field}
          touched={encounterDiagnosisTouched?.[icd10Field]}
          errors={encounterDiagnosisErrors?.[icd10Field]}
          fieldLabel={fieldLabel}
          onFieldFocus={() => {
            if (!listICD10?.length) {
              handleGetListICD10();
            }
          }}
          inputClassName="rounded-end-0"
        />
      </Col>
      <Col xs="9" className={clsx("ps-0", endRowClassName)}>
        <SelectTableVirtualized
          value={
            listICD10.find(
              (item: any) =>
                item.code === encounterDiagnosisValues?.[icd10Field]
            )?.name ||
            encounterDiagnosisValues?.[icd10Field + "Name"] ||
            ""
          }
          setICD10Selected={(value) => {
            handleSelectedICD10(value);
          }}
          columns={columnSelectTable}
          data={listICD10}
          label=""
          labelClassName="min-w-120-px"
          disabled={isDisabled}
          keyword="name"
          name={icd10Field + "Name"}
          touched={encounterDiagnosisTouched?.[icd10Field + "Name"]}
          errors={encounterDiagnosisErrors?.[icd10Field + "Name"]}
          fieldLabel={fieldLabel}
          onFieldFocus={() => {
            if (!listICD10?.length) {
              handleGetListICD10();
            }
          }}
          inputClassName="rounded-start-0 border-start-0"
        />
      </Col>
      {hasDiagnosisNonCoded && (
        <Col xs="12" className={clsx(rowClassName, endRowClassName)}>
          <TextField
            className="spaces pt-2 ml-0"
            name={diagnosisNonCodedField}
            value={encounterDiagnosisValues?.[diagnosisNonCodedField] || ''}
            onChange={(e: any) =>
              handleChangeEncounterDiagnosis(e.target.name, e.target.value)
            }
            disabled={isDisabled}
            placeholder="Chẩn đoán ngoài ICD10"
            touched={encounterDiagnosisTouched?.[diagnosisNonCodedField]}
            errors={encounterDiagnosisErrors?.[diagnosisNonCodedField]}
          />
        </Col>
      )}
    </>
  );
};

export default React.memo(ProvisonalDiagnosis);
